import {
  AutoScheduleSchema,
  AutoScheduleSchemaType,
} from 'modules/shift_management/lib/forms/AutoSchedule/schema'

const Form = () => {
  const defaultValues: AutoScheduleSchemaType = {
    locationId: 0,
    startAt: '',
    endAt: '',
    restDaysPerWeek: true,
    agreementHours: true,
    restHoursBetweenShifts: true,
    maxWorkHoursPerDay: true,
    employeeSelection: { type: 'manual', ids: [] },
  }

  return {
    defaultValues,
    schema: AutoScheduleSchema(),
  }
}

export { Form }
